export default "__VITE_ASSET__ZhTmlxAP__"